<template lang="pug">
  Auth(@loggedIn="onLoggedIn"
    :redirectWithLoginFailed="true")
    SlideHeader(v-if="headerContent && slide" :content="headerContent" :slide="slide")
    ModulePageChanger(v-if="pages && slide.createdBy == uid"
      v-show="showPageChanger"
      :pages="pages" @togglePageChanger="togglePageChanger")
    div.wrap-slide
      ModuleSlide(v-if="slide && pages && me && users[0] && initialized"
        :slide="slide" :pages="pages"
        :doodles="doodles" :messages="messages"
        :users="users" :me="me")
    ModalWindow(:show="showInvitationWindow" @hideModal="showInvitationWindow = false")
      div.wrap-window.px30.py30
        span.text-center.block.mb14 Let's invite friends!
        ItemShareButtons(v-if="currentURL" :url="currentURL" hashtags="ClassJack")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-slide {
  width: 100%;
  min-height: 100vh;
  background: $primary_bg_color;
}

.wrap-window {
  background: $primary_bg_color;
  border-radius: 3px;
  // width: 280px;
}
</style>

<script>
import { domain } from '@/components/utils/config'
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import SlideHeader from '@/components/shared/SlideHeader'
import ModalWindow from '@/components/shared/ModalWindow'
import ModuleSlide from '@/components/module/ModuleSlide'
import ModulePageChanger from '@/components/module/ModulePageChanger'
import ItemShareButtons from '@/components/item/ItemShareButtons'

export default {
  components: {
    Auth,
    SlideHeader,
    ModalWindow,
    ModuleSlide,
    ModulePageChanger,
    ItemShareButtons
  },
  data () {
    return {
      slide: null,
      pages: null,
      doodles: [],
      messages: [],
      me: null,
      users: [],
      headerContent: {
        title: '',
        left: {
          icon: 'mdi-close',
          action: this.backPage
        },
        // lefts: [
        //   {
        //     icon: 'mdi-close',
        //     action: this.backPage
        //   },
        //   {
        //     icon: 'mdi-close',
        //     action: this.backPage
        //   }
        // ],
        right: {}
      },
      showInvitationWindow: false,
      currentURL: null,
      previousPage: null,
      initialized: false,
      showPageChanger: false
    }
  },
  async created () {
    database.slideCollection()
      .getSlideInRealtime(this.$route.params.slideId, this.updateSlide)
    
    database.slideCollection()
      .getDoodlesInRealtime(this.$route.params.slideId, this.updateDoodles)

    database.slideCollection()
      .getMessageInRealtime(this.$route.params.slideId, this.updateMessages)

    this.pages = await database.slideCollection()
      .getPages(this.$route.params.slideId)

    // ユーザーのinitializeが終わってから更新
    // const ts = new Date().getTime()
    // const dateAfter1Hour = new Date(ts + (1000 * 60 * 60 * 1))
    // database.userCollection()
    //   .getUsersInSlideInRealtime(this.$route.params.slideId, dateAfter1Hour, this.updateUsers)

    this.currentURL = `${domain}${this.$route.path}`
  },
  destroyed () {
    this.updateJoiningStatus()
    window.removeEventListener('beforeunload', this.updateJoiningStatus)
  },
  beforeRouteEnter(to, from, next) {
    const self = this
    next((vm) => {
      vm.from = from
      window.previousPageBeforeSlide = from
    })
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    async onLoggedIn () {
      window.addEventListener('beforeunload', this.updateJoiningStatus)

      this.me = await database.userCollection()
        .findById(this.uid)
      
      const random0to10 = () => Math.floor(Math.random() * 100)
      const newPos = { x: random0to10(), y: random0to10() }
      this.me.pos = newPos
      
      if (this.me.joiningSlide
       && this.me.joiningSlide === this.$route.params.slideId) {
        await database.userCollection()
          .update(this.uid, { 
              pos: newPos,
              joinedAt: new Date()
            })
        // console.log('join up again!')
      } else {
        let userUpdate = {
          joiningSlide: this.$route.params.slideId,
          joinedAt: new Date(),
          pos: newPos
        }
        // 詰んだ人対策で再入場するとポジションが自動でランダムに変更されるようにする
        // if (!this.me.pos) {
        //   const random0to10 = () => Math.floor(Math.random() * 100)
        //   userUpdate.pos = { x: random0to10(), y: random0to10() }
        // }
        await database.userCollection()
          .update(this.uid, userUpdate)
        // console.log('join up!')
      }

      this.initialized = true
      const ts = new Date().getTime()
      const dateAfter1Hour = new Date(ts + (1000 * 60 * 60 * 1))
      database.userCollection()
        .getUsersInSlideInRealtime(this.$route.params.slideId, dateAfter1Hour, this.updateUsers)
    },
    updateJoiningStatus (event) {
      // event.returnValue = '編集中のものは保存されませんが、よろしいですか？'
      if (this.uid) {
        database.userCollection().update(this.uid, { 
          joiningSlide: ''
        })
      }
    },
    updateSlide (d) {
      this.slide = d.data()
      this.headerContent.title = this.slide.title

      if (this.slide.createdBy === this.uid) {
        this.headerContent.lefts = [
          {
            icon: 'mdi-close',
            action: this.backPage
          },
          {
            icon: 'mdi-animation-outline',
            action: this.togglePageChanger
          }
        ]
        if (this.slide.status === 'draft') {
          this.headerContent.right = {
            label: 'Publish!',
            color: this.pallete.$active_color,
            action: this.publishSlide
          }
        }
      }
      if (this.slide.status === 'published') {
        // 一時的にこの機能は隠す
        // this.headerContent.right = {
        //   icon: 'mdi-share-variant',
        //   color: this.pallete.$active_color,
        //   action: this.onInvite
        // }
      }
    },
    updateDoodles (q) {
      this.doodles = q.docs.map(d => {
        return { id: d.id, ...d.data() }
      })
      // console.log('updateDoodles:', this.doodles)
    },
    updateMessages (q) {
      this.messages = q.docs.map(d => {
        return { id: d.id, ...d.data() }
      })
      // console.log('updateMessages:', this.messages)
    },
    updateUsers (q) {
      this.users = q.docs.map(d => {
        return { id: d.id, ...d.data() }
      })

      const me = this.users.filter(u => u.uid === this.uid)[0]
      if (me) this.me.pos = me.pos
      // this.me = this.users.filter(u => u === this.uid)[0]
      // console.log('updateUsers:', this.users)
    },
    async publishSlide () {
      await database.slideCollection().update(this.$route.params.slideId, {
        status: 'published'
      })
      this.showInvitationWindow = true
    },
    onInvite () {
      this.showInvitationWindow = true
    },
    backPage () {
      if (window.previousPageBeforeSlide && window.previousPageBeforeSlide.name) {
        this.$router.go(-1)
      } else {
        this.$router.push('/home')
      }
    },
    togglePageChanger () {
      this.showPageChanger = !this.showPageChanger
    }
  }
}
</script>
